// extracted by mini-css-extract-plugin
export default {"elementMenu":"InlineElementMenuButton_elementMenu__-yoUT","pageless":"InlineElementMenuButton_pageless__bwqhd"};